"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Stack__Container",
  componentId: "sc-1gdj2vq-0"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;justify-content:", ";align-items:", ";", " > * + *{margin-top:", ";}", ""], _units.justifyMap[props.justify], _units.alignMap[props.align], props.justify === 'stretch' && (0, _styledComponents.css)(["> *{flex-grow:1;}"]), _units.globalSizes[props.gap], props.splitAfter && (0, _styledComponents.css)(["& >:nth-child(", "){margin-bottom:auto;}"], props.splitAfter));
});
/**
 * ### Layout primitive component
 *
 * The **Stack** is a container component that displays its children along a single (vertical) dimension.
 *
 * The `align` and `justify` props can be used to position child contents relative to the **Stack** direction.
 *
 * the `splitAfter` prop allows the stack to be broken into two sections (top and bottom) with a variable space
 *
 * divider.
 */

var Stack = /*#__PURE__*/_react["default"].forwardRef(function Stack(_ref, ref) {
  var children = _ref.children,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'stretch' : _ref$align,
      className = _ref.className,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'div' : _ref$element,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 'none' : _ref$gap,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'auto' : _ref$height,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? 'start' : _ref$justify,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'none' : _ref$padding,
      _ref$splitAfter = _ref.splitAfter,
      splitAfter = _ref$splitAfter === void 0 ? null : _ref$splitAfter,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width,
      rest = _objectWithoutProperties(_ref, ["children", "align", "className", "element", "gap", "height", "justify", "padding", "splitAfter", "width"]);

  return /*#__PURE__*/_react["default"].createElement(Container, _extends({
    align: align,
    className: className,
    element: element,
    gap: gap,
    height: height,
    justify: justify,
    padding: padding,
    splitAfter: splitAfter,
    width: width,
    ref: ref
  }, rest), children);
});

var _default = Stack;
exports["default"] = _default;